export enum UserRoles {
  MEMBER = 'member',
  ADMIN = 'admin',
}

export type UserRole = UserRoles.MEMBER | UserRoles.ADMIN
